import httpService from "./http.service";

class ReqGlassesService {
  getReqGlassesUrl = "/request-glass";

  getReqGlasses = (status = 'pending') => {
    return httpService.get(`/request-glass?status=${status}`);
  };

  answerdReqGlasses = (reqId) => {
    return httpService.patch(`/request-glass/${reqId}`);
  };
}

const reqGlassesService = new ReqGlassesService();
export default reqGlassesService;
